import React from "react";
import {Modal, Paper, Button, ButtonBase, Avatar, Chip} from "@material-ui/core";
import {ChevronRight} from "@material-ui/icons";
import {makeStyles} from "@material-ui/styles";
import {datasetLabel} from "../../../../helpers/datasetLabels";

const useStyles = makeStyles(() => ({
    dialog: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 'none',
        width: 400,
        maxWidth: 'calc(100vw - 32px)',
        maxHeight: '100%',
        overflowY: 'auto',
        borderRadius: 8,
    },
    body: {
        padding: '20px 20px 16px',
    },
    title: {
        margin: 0,
        fontSize: 17,
        fontWeight: 700,
        color: '#1d1d24',
    },
    subtitle: {
        margin: '4px 0 0',
        fontSize: 13,
        color: '#6b6b76',
    },
    // The person row opens the preview, so it reads as a button, not as text.
    person: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        width: '100%',
        marginTop: 16,
        padding: '10px 12px',
        border: '1px solid #e7e7ea',
        borderRadius: 6,
        textAlign: 'left',
        '&:hover': {
            borderColor: '#224edf',
            backgroundColor: 'rgba(34, 78, 223, 0.04)',
        },
    },
    avatar: {
        width: 36,
        height: 36,
        fontSize: 16,
        backgroundColor: '#224edf',
    },
    personInfo: {
        flex: 1,
        minWidth: 0,
    },
    name: {
        fontSize: 15,
        fontWeight: 700,
        color: '#1d1d24',
    },
    datasets: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 4,
        marginTop: 4,
    },
    chip: {
        height: 18,
        fontSize: 11,
    },
    view: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        fontWeight: 500,
        color: '#224edf',
        whiteSpace: 'nowrap',
    },
    question: {
        margin: '16px 0 0',
        fontSize: 14,
        color: '#1d1d24',
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 8,
        padding: '12px 20px',
        borderTop: '1px solid #e7e7ea',
    },
}));

const PersonMatchDialog = (
    {
        open, name, datasets, canImport = true,
        onAccept, onDecline, onPreview, dismissible = false,
    }
) => {
    const classes = useStyles();
    const labels = (datasets || []).map(datasetLabel).filter(Boolean);

    return (
        <Modal open={open} onClose={dismissible ? onDecline : () => {}}>
            <Paper className={classes.dialog}>
                <div className={classes.body}>
                    <h2 className={classes.title}>Possible match found</h2>
                    <p className={classes.subtitle}>This person is already in the database.</p>

                    <ButtonBase className={classes.person} onClick={onPreview} focusRipple>
                        <Avatar className={classes.avatar}>{(name || '?').charAt(0)}</Avatar>
                        <div className={classes.personInfo}>
                            <div className={classes.name}>{name}</div>
                            {labels.length > 0 && (
                                <div className={classes.datasets}>
                                    {labels.map((label) => (
                                        <Chip key={label} size="small" label={label} className={classes.chip}/>
                                    ))}
                                </div>
                            )}
                        </div>
                        <span className={classes.view}>
                            View details
                            <ChevronRight fontSize="small"/>
                        </span>
                    </ButtonBase>

                    <p className={classes.question}>
                        {canImport
                            ? 'Do you want to import its data?'
                            : 'Do you want to link this contact to that person?'}
                    </p>
                </div>
                <div className={classes.actions}>
                    <Button onClick={onDecline}>No</Button>
                    <Button onClick={onAccept} variant="contained" color="primary" disableElevation>
                        Yes, link
                    </Button>
                </div>
            </Paper>
        </Modal>
    );
};

export default PersonMatchDialog;
